import { gsap } from 'gsap'
import { setSplitTitle } from '@scripts/animations/set-split-title'

interface SplitTitle {
  lines: Element[]
  destroy(): void
}

export function heroProjects(element: Element) {
  let mm = gsap.matchMedia()
  let tl: GSAPTimeline
  let setDesc: SplitTitle
  let setTitles: SplitTitle
  const imageSections = [...Array.from(element.querySelectorAll('.js-image-section'))] as HTMLElement[]
  const desc = element.querySelector('.js-desc') as HTMLElement
  const title = element.querySelector('.js-title') as HTMLElement
  const label = element.querySelector('.js-label') as HTMLElement

  const handleResize = () => {}

  function init(): void {
    mm.add('(min-width: 830px)', () => {
      // Add the handleResize function to the window resize event
      // window.addEventListener('resize', handleResize);

      if (label) gsap.set(label, { autoAlpha: 0, yPercent: 50 })
      if (desc) setDesc = setSplitTitle(desc as HTMLElement)
      if (title) setTitles = setSplitTitle(title as HTMLElement)
      if (imageSections.length > 0) gsap.set(imageSections, { yPercent: 50, autoAlpha: 0 })

      tl = gsap.timeline({
        defaults: {
          duration: 1,
          ease: 'expo.out'
        },
        onComplete: () => {
          if (label) gsap.set([label], { clearProps: 'all' })
          if (imageSections.length > 0) gsap.set(imageSections, { clearProps: 'all' })
        }
      })

      if (label) tl.to(label, { yPercent: 0, autoAlpha: 1, duration: 1.5, stagger: 0.15 }, 0)
      if (setTitles) tl.to([setTitles.lines], { yPercent: 0, stagger: 0.15, duration: 0.9 }, 0)
      if (setDesc) tl.to([setDesc.lines], { yPercent: 0, stagger: 0.15, duration: 0.9 }, 0)
      if (imageSections.length > 0) tl.to([imageSections], { yPercent: 0, autoAlpha: 1, duration: 1.5, stagger: 0.15 }, 0)
    })
  }

  function destroy(): void {
    // mm.revert()
    if (label) gsap.set([label], { clearProps: 'all' })
    if (imageSections.length > 0) gsap.set(imageSections, { clearProps: 'all' })

    if (setDesc) setDesc.destroy()
    if (setTitles) setTitles.destroy()

    tl.kill()
    // if (trigger && trigger.scrollTrigger) {
    //   trigger.scrollTrigger.kill() // Kill the ScrollTrigger
    //   trigger = null
    //  }
  }

  // Return the init and destroy functions
  return {
    init,
    destroy
  }
}
